import { useRef, useState } from 'react';

import Calendar from "@fullcalendar/react";
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import { useTranslation } from 'react-i18next';

import moment from "moment";
import "moment/locale/ko";

import { ReactComponent as AvatarIcon } from "asset/calendar/avatarIcon_black.svg";
import { ReactComponent as LocationIcon } from "asset/calendar/location_outlined.svg";
import MyResDetailPop from '../component/myResDetailPop';

function HourlyCalendar({ scheduleList, date, monthlyCalType }) {
    const { t, i18n } = useTranslation();

    const calendarRef = useRef(null);

    // const [calendarApi, setCalendarApi] = useState(null);

    const resources = [
        {
            id: "H",
            title: "HotDesking"
        },
        {
            id: "M",
            title: "Meeting"
        },
    ];

    const localeConverter = () => {
        if (i18n.language === "en-US") {
            return "en";
        } else {
            return "ko";
        }
    };

    const dayConverter = (value, rtnToday) => {
        const isToday = moment(value).isSame(moment(), "day");
        if (isToday && rtnToday) return "Today";
        if (i18n.language === "en-US") {
            return moment(value).locale("en").format("ddd");
        } else {
            return moment(value).locale("ko").format("dd");
        }
    };

    const getTimeforHourlySchedule = (startDateTime, endDateTime) => {
        const options = { hour: '2-digit', minute: '2-digit', hour12: false };

        const startTime = new Date(startDateTime).toLocaleTimeString([], options);
        const endTime = new Date(endDateTime).toLocaleTimeString([], options);

        return `${startTime}-${endTime}`;
    }

    const titleDate = () => {
        if (i18n.language === "en-US")
            return moment(date).locale('en').format("MMMM D, YYYY (dddd)");
        else
            return moment(date).locale('ko').format("YYYY년 M월 D일 (dddd)");
    }

    // useEffect(() => {
    //     if (calendarRef !== undefined) {
    //         let calApi = calendarRef.current.getApi();
    //         setCalendarApi(calApi);
    //     }
    // }, [calendarRef, date]);

    const getEndpoint = (endpointStr) => {
        return endpointStr !== undefined && endpointStr !== "" ? endpointStr.split(";")[0] : "-";
    }

    // schedule detail pop
    const [isDetailOpen, setIsDetailOpen] = useState(false);
    const [detailType, setDetailType] = useState("");
    const [scheduleId, setScheduleId] = useState("");
    const [hotdeskingDetail, setHotdeskingDetail] = useState({});

    const scheduleDetailOpenHandler = (type, data) => {
        setDetailType(type);
        if (type === 'M') {
            setScheduleId(data.SCHEDULE_ID);
        } else if (type === "H") {
            setHotdeskingDetail(data);
        }
        setIsDetailOpen(true);
    }

    const closePopHandler = () => {
        setIsDetailOpen(false);
        setDetailType("");
        setScheduleId("");
        setHotdeskingDetail({});
    }
    return (
        <div className='calendar-hourly' style={{ height: `calc(100% - ${monthlyCalType === "dayGridMonth" ? 515 : 217}px` }}>
            <MyResDetailPop
                isOpen={isDetailOpen}
                scheduleType={detailType}
                data={detailType === 'M' ? scheduleId : detailType === 'H' ? hotdeskingDetail : null}
                closePop={closePopHandler}
            />
            <div className='title'>
                {titleDate()}
            </div>
            <Calendar
                // slotMinTime="09:00:00" // Start time (8 AM)
                // slotMaxTime="18:00:00" // End time (6 PM)
                resourceLabelDidMount={(info) => {
                    info.el.style.display = "none"; // 리소스 헤더 없애기
                }}
                height={`calc(100% - 56px)`}
                schedulerLicenseKey="0820383817-fcs-1688451544"
                initialDate={date}  // 초기 날짜
                key={date}          // 변경 날짜 적용
                resources={resources}
                ref={calendarRef}
                plugins={[resourceTimeGridPlugin]}
                initialView="resourceTimeGridDay"
                timeZone="Asia/Seoul"
                locale={localeConverter()}
                expandRows={true}
                // fixedWeekCount={false}
                dayMaxEventRows={true}
                scrollTime={moment().subtract(30, "minutes").format("HH:mm:ss")}
                headerToolbar={false}
                views={{
                    resourceTimeGridDay: {
                        slotLabelFormat: {
                            hour: "numeric",
                            minute: "2-digit",
                            hour12: false,
                        },
                        eventTimeFormat: {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                        },
                        dayHeaderContent: function (arg) {
                            return {
                                html:
                                    "<div className='weekday'>" +
                                    dayConverter(arg.date) +
                                    "</div><div className='date'>" +
                                    moment(arg.date).format("DD") +
                                    "</div>",
                            };
                        },
                    },
                }}
                events={scheduleList}
                eventContent={(e) => {
                    const data = e.event._def.extendedProps;
                    const type = e.event._def.resourceIds[0];
                    if (type === 'M') {   // 회의 (Meeting)
                        return (
                            <div
                                className='hourly-schedule'
                                style={{ cursor: "pointer" }}
                                onClick={() => scheduleDetailOpenHandler(type)}
                            >
                                <div className='header'>
                                    <div className='left'>
                                        {data.TITLE}
                                        {/* <div className='title'>{data.TITLE}</div> */}
                                    </div>
                                    <div className='right'>{getTimeforHourlySchedule(data.START_DATETIME, data.END_DATETIME)}</div>
                                </div>
                                <div className='footer'>
                                    <div className='location'><LocationIcon />{getEndpoint(data.ENDPOINTLIST)}</div>
                                    <div className='participant'><AvatarIcon />{`${data.PARTICIPANTS !== null && data.PARTICIPANTS !== undefined && data.PARTICIPANTS.length}`}</div>
                                </div>
                            </div>
                        )
                    } else if (type === 'H') {   // Hotdesking
                        if (data.hotdeskDetail !== null) {
                            return (

                                <div
                                    className='hourly-schedule'
                                    style={{ cursor: "pointer" }}
                                    onClick={() => scheduleDetailOpenHandler(type)}
                                >
                                    <div className='header' style={{ position: "sticky", top: 0 }}>
                                        <div className='left'>
                                            {/* {data.resource.id} */}
                                            {data.resource.title}
                                            {/* <div className='title'>{data.TITLE}</div> */}
                                        </div>
                                        <div className='right'>{getTimeforHourlySchedule(data.startDttm, data.endDttm)}</div>
                                    </div>
                                    <div className='footer'>
                                        <div className='location'><LocationIcon />{data.resource.location.title}</div>
                                        {/* <div className='participant'><AvatarIcon />{`${data.PARTICIPANTS.length} 명`}</div> */}
                                    </div>
                                </div>
                            )
                        } else {
                            return (
                                <div></div>
                            )
                        }
                    }
                }}
                eventClick={(e) => {
                    const type = e.event._def.resourceIds[0];
                    const data = e.event._def.extendedProps;
                    scheduleDetailOpenHandler(type, data);
                }}
                slotDuration="00:10:00"
                allDaySlot={false} //Week,day 일때 all-day 슬롯 표출 여부
                nowIndicator={true} //현재 시간을 나타내는 마커를 표시할지 여부.
                nowIndicatorDidMount={(info) => {
                    // info.el.style.backgroundColor = "blue"; // Change color dynamically
                    // info.el.style.borderTop = "1.5px solid #000"; // Customize the line
                    info.el.style.color = "#fff";
                }}
            />
        </div>
    )
}

export default HourlyCalendar
